import React from 'react'
import { ErrorModal } from '../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY } from '../../../dataHelpers/authenticationHelpers'
import { Button, Form, FormGroup, Input, InputGroup } from 'reactstrap'
import { AppError } from "../../../models"
import Loader from 'react-loader-spinner'
import { NO_VALUE, ENTER_EXPIRING_DAYS, SUCCESS, VALID_EXPIRING_DAYS,ABOUT_EXPIRE_DAYS_UPDATE } from '../../../constants'

class SetAboutExpireDays extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            expireDaysTxtVal: '',
            defaultPkId:''

        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.dismissError = this.dismissError.bind(this)
    }

    componentDidMount(){
        this.getDefaultSubscriptionPlan()
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async getDefaultSubscriptionPlan() {
        try {
            let defaultSubsPlanData = await subscriptionHelpers.getDefaultSubsPlan(this.token)
            if (!defaultSubsPlanData.error) {
                this.setState({ defaultPkId: defaultSubsPlanData[0].id, expireDaysTxtVal: (defaultSubsPlanData[0].about_expire_days).toString() })
            } else {
                this.setState({ errors: [defaultSubsPlanData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { defaultPkId, expireDaysTxtVal } = this.state
        if (!expireDaysTxtVal || expireDaysTxtVal === '') {
            let appError = new AppError(NO_VALUE, ENTER_EXPIRING_DAYS)
            await this.setState({ errors: [appError], loading: false })
            return
        } else if (!expireDaysTxtVal.match(/^\d+(\.\d+)?$/)) {
            let appError = new AppError(NO_VALUE, VALID_EXPIRING_DAYS)
            await this.setState({ errors: [appError], loading: false })
            return
        } else {
            let aboutExpireResponse = await subscriptionHelpers.setAboutExpireDays(this.token, defaultPkId, expireDaysTxtVal)
            if (!aboutExpireResponse.error) {
                let appError = new AppError(SUCCESS, ABOUT_EXPIRE_DAYS_UPDATE)
                await this.setState({ errors: [appError], loading: false })
                this.getDefaultSubscriptionPlan()
                return
            } else {
                this.setState({ errors: [aboutExpireResponse.error] })
            }
        }
    }

    render() {
        let { errors, loading, expireDaysTxtVal } = this.state
        return (<div>
            <br />
            <br />
            <h1 className="col-12">About Expire Days</h1>
            <br />
            <div className="row justify-content-center align-items-center">
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-4 col-md-8 col-sm-10">
                        <FormGroup>
                            <InputGroup>
                                <Input type="discountLabel"
                                       placeholder={`Enter About Expire Days`}
                                       value={expireDaysTxtVal}
                                       onChange={(evt) => this.setState({ expireDaysTxtVal: evt.target.value })}
                                       maxLength={3}
                                />
                            </InputGroup>
                            <br />
                        </FormGroup>
                        <Button>Save</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                                modal={true}
                                toggle={() => (this.dismissError(appError))}
                                text={appError.text}
                                title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default SetAboutExpireDays



// WEBPACK FOOTER //
// ./src/components/pages/subscription/SetAboutExpireDays.js